// Base interface for client environment variables
export interface ClientEnv {
  CLOUDFLARE_ACCOUNT_HASH: string
  CLOUDFLARE_IMAGES_URL: string
  CONVEX_URL: string
  CONVEX_SITE_URL: string
}

// Validation helper
export function validateEnv(env: Partial<ClientEnv>, source: string): ClientEnv {
  const missing: string[] = []

  if (!env.CONVEX_URL) missing.push("CONVEX_URL")
  if (!env.CONVEX_SITE_URL) missing.push("CONVEX_SITE_URL")

  if (missing.length > 0) {
    throw new Error(`Missing required environment variables in ${source}: ${missing.join(", ")}`)
  }

  return {
    CLOUDFLARE_ACCOUNT_HASH: env.CLOUDFLARE_ACCOUNT_HASH || "",
    CLOUDFLARE_IMAGES_URL: env.CLOUDFLARE_IMAGES_URL || "",
    CONVEX_URL: env.CONVEX_URL!,
    CONVEX_SITE_URL: env.CONVEX_SITE_URL!,
  }
}
